<div *ngIf="isVisible()">
  <canvas baseChart width="600" height="280" [datasets]="datasets" [colors]="chartColors"
    [labels]="labels" [options]="options" [chartType]="type">
  </canvas>
</div>
